"use client";

import * as React from "react";
import { TrendingUp } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RealTimeWinRateLeaderboard() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const leaderboardData = [{
    rank: 1,
    name: "2021 Baseline Year",
    winRate: 100.0
  }, {
    rank: 2,
    name: "Current Market Index",
    winRate: 84.2
  }, {
    rank: 3,
    name: "Regional Average",
    winRate: 72.8
  }, {
    rank: 4,
    name: "Historical Median",
    winRate: 61.5
  }, {
    rank: 5,
    name: "Critical Threshold",
    winRate: 45.0
  }];
  return <section data-section-id="253554" id="scoring-scale-baseline" ref={ref} className="bg-background text-foreground py-16 px-4 md:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 flex items-center gap-3">
          <TrendingUp className="h-8 w-8 text-primary" />
          <h2 className="font-default text-2xl md:text-3xl font-bold uppercase tracking-wider">Scoring Scale & Baseline</h2>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[40%_60%] gap-8 lg:gap-12">
          {}
          <div className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-4"}`}>
            <div className="bg-black rounded-none border-none shadow-none overflow-hidden">
              <Table>
                <TableHeader>
                  <TableRow className="border-b border-white/20 hover:bg-transparent">
                    <TableHead className="w-12 text-center px-3 py-4 text-white font-mono">RANK</TableHead>
                    <TableHead className="px-4 py-4 text-white font-mono">METRIC CATEGORY</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {leaderboardData.map((item, i) => <TableRow key={i} data-index={i} className="border-b border-white/10 hover:bg-white/5 transition-colors">
                      <TableCell className="text-center px-3 py-4">
                        <span className="inline-flex h-8 w-8 items-center justify-center rounded-none bg-white text-black font-mono font-bold text-sm">
                          {item.rank}
                        </span>
                      </TableCell>
                      <TableCell className="px-4 py-4 font-mono text-sm md:text-base text-white">
                        {item.name}
                      </TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>
          </div>

          {}
          <div className={`transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-4"}`}>
            <div className="space-y-8">
              {leaderboardData.map((item, i) => <div key={i} data-index={i} className="space-y-3">
                  <div className="flex items-center justify-between">
                    <h3 className="font-default text-sm md:text-base font-bold text-foreground uppercase">
                      {item.name}
                    </h3>
                    <span className="font-mono text-base md:text-lg font-bold text-chart-2">
                      {item.winRate.toFixed(1)}
                    </span>
                  </div>

                  <div className="relative h-3 w-full overflow-hidden rounded-none bg-muted">
                    <div className="absolute inset-0 rounded-none bg-chart-2 transition-all duration-1000" style={{
                  width: isVisible ? `${item.winRate}%` : "0%"
                }}>
                      <div className="absolute right-0 top-0 h-full w-1 blur-none bg-white/30" />
                    </div>
                  </div>

                  <div className="flex justify-between text-xs font-mono text-muted-foreground">
                    <span>0.0</span>
                    <span>100.0 (BASE)</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}